import _ from 'lodash';
import * as actionTypes from 'constants/ActionTypes';

const notifications = (state = {
    items: [],
}, action) => {
    switch (action.type) {
        case actionTypes.ADD_NOTIFICATION: {
            const items = _.cloneDeep(state.items);

            items.push(action.notification);

            return {
                ...state,
                items,
            };
        }
        case actionTypes.DELETE_NOTIFICATION: {
            const items = state.items.filter((item) => {
                return item._id !== action.notification._id;
            });

            return {
                items,
            };
        }
        default:
            return state;
    }
};

export default notifications;



// WEBPACK FOOTER //
// ./app/reducers/notifications/notifications.js